import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { CenterVerticalRow, StyledWrapper } from 'styles/ContainerStyles';
import {
  LicensePlate,
  Maybe,
  Pmc,
  UnifiedPermit,
} from 'types/generatedSchemaTypes';
import { getLicensePlatesText } from 'utils/permitUtils';
import TicketRow from './TicketRow';
import { useUiStore } from 'stores/uiStore';

type VehicleRowProps = {
  uid?: string;
  registrationPlates: LicensePlate[];
  permit: UnifiedPermit;
  pmc?: Maybe<Pmc>;
};
const VehicleRow = ({
  uid,
  registrationPlates,
  permit,
  pmc,
}: VehicleRowProps) => {
  const { t } = useTranslation();
  const licensePlateColor = registrationPlates?.[0]
    ? theme.colors.black
    : theme.colors.boost.red;

  const handleVehiclePress = () => {
    if (
      permit?.permitType === 'SALES_ORDER' &&
      pmc?.reservationType === 'RESERVED'
    ) {
      usePermitStore
        .getState()
        .setSelectedPermit(permit?.orderLineIdWithVersion ?? '');
      useUiStore.getState().setSheetModal('registrationPlates');
    }
  };

  return (
    <TicketRow
      title={t('services.permitVehicle')}
      testID={`permit-${uid}-vehicle`}
      onPress={handleVehiclePress}>
      <Meta color={licensePlateColor} testID={`permit-${uid}-vehicle`}>
        <CenterVerticalRow>
          <Meta>{getLicensePlatesText(registrationPlates)}</Meta>
          <StyledWrapper mb={0}>
            {pmc?.reservationType === 'RESERVED' &&
            registrationPlates?.length > 2 ? (
              <Icon name="Chevron_Right" size="s" />
            ) : null}
          </StyledWrapper>
        </CenterVerticalRow>
      </Meta>
    </TicketRow>
  );
};

export default VehicleRow;
